/**
 * File: aria-burger-menu.js
 *
 * Import and initialize functions for zoom accessibility issue
 */

 export default {
	init() {
		this.render();
	},
	render() {
		const mobileMenu = document.querySelector(".menu_mobile_fullscreen");
		const mobileMenuChildren = mobileMenu.querySelectorAll('*');
		const mobileNavArea = mobileMenu.querySelector('.menu_mobile_nav_area');
		const mobileMenuButtons = document.querySelectorAll(".sc_layouts_menu_mobile_button_burger > .sc_layouts_item_link");
		const mobileMenuClose = mobileMenu.querySelector(".menu_mobile_close");
		const subMenuToggles = mobileMenu.querySelectorAll(".open_child_menu");

		const menuSiblings = [...mobileMenu.parentElement.children]
				.filter(child => child !== mobileMenu);

		const nonMobileMenuElements = [...document.body.children]
			.filter(child => !child.classList.contains("body_wrap"));

		if (!mobileMenu || mobileMenuButtons.length === 0 || !mobileMenuClose) return;

		// modify mobile menu close aria-label
		mobileMenuClose.setAttribute("aria-label", "Close Menu");
		mobileMenuButtons.forEach(button => button.setAttribute("tabindex", 0));

		function setVoiceOverFocus(element) {
			var focusInterval = 20; // ms, time between function calls
			var focusTotalRepetitions = 100; // number of repetitions

			element.setAttribute('tabindex', '-1');
			element.blur();
			var focusRepetitions = 0;
			var interval = window.setInterval(function() {
				element.focus();
				focusRepetitions++;
				if (focusRepetitions >= focusTotalRepetitions) {
					window.clearInterval(interval);
				}
			}, focusInterval);
		}

		const handleMobileMenuClick = () => {
			mobileMenuChildren.forEach(child => child.setAttribute('aria-hidden', 'false'));
			mobileMenuChildren.forEach(child => child.removeAttribute('tabindex'));
			mobileMenu.setAttribute('aria-hidden', 'false');
			mobileMenu.removeAttribute('tabindex');

			[...nonMobileMenuElements, ...menuSiblings]
				.forEach(sibling => sibling.setAttribute("aria-hidden", true));

			handleSubMenus(true);
			setVoiceOverFocus(mobileNavArea);
		};

		const handleMobileMenuClose = () => {
			mobileMenuChildren.forEach(child => child.setAttribute('aria-hidden', 'true'));
			mobileMenuChildren.forEach(child => child.setAttribute('tabindex', '-1'));
			mobileMenu.setAttribute('aria-hidden', 'true');
			mobileMenu.setAttribute('tabindex', '0');

			[...nonMobileMenuElements, ...menuSiblings]
				.forEach(sibling => sibling.setAttribute("aria-hidden", false));

			handleSubMenus(false);
		};

		const handleKeydowns = (key, element, callback) => {
			if (!key || key === "Enter") {
				element.click();
				callback && callback();
			}
		}

		const handleSubMenus = (isActive) => {
			// makes the submenu toggles focusable
			subMenuToggles.forEach(toggle => {
			const subMenuName = toggle.previousElementSibling?.textContent;
			const isExpanded = toggle.parentElement?.parentElement.classList.contains("opened");
			const subMenuLinks = toggle.parentElement?.nextElementSibling?.querySelectorAll("a[href]");

			toggle.setAttribute("aria-label", `Click to ${isExpanded ? "Collapse" : "Expand"} ${subMenuName} Menu`);
			toggle.setAttribute("tabindex", isActive ? 0 : -1);

			subMenuLinks.forEach(link => {
				const span = link.querySelector("span");
				link.setAttribute("aria-hidden", !isExpanded);
				link.setAttribute("tabindex", !isExpanded ? "-1" : "0");
				span.setAttribute("aria-hidden", !isExpanded);
			});
		});
		}

		handleMobileMenuClose();

		// handle clicks
		mobileMenuClose.addEventListener('click', handleMobileMenuClose);
		
		mobileMenuButtons.forEach(button =>
			button.addEventListener('click', handleMobileMenuClick));

		subMenuToggles.forEach(button =>
			button.addEventListener('click', handleSubMenus));

		// handle keydowns
		mobileMenuButtons.forEach(button => {
			button.addEventListener('keydown', ({ key }) => 
				handleKeydowns(key, button, handleMobileMenuClick));
		});

		mobileMenuClose.addEventListener('keydown', ({ key }) =>
			handleKeydowns(key, mobileMenuClose, handleMobileMenuClose));

		subMenuToggles.forEach(toggle => toggle.addEventListener('keydown', ({ key }) => 
			handleKeydowns(key, toggle, handleSubMenus)));
	},
};
